import { useNextApiSubscription } from '@newfront-insurance/next-api-swr';
import type { NextApiSubscription } from '@newfront-insurance/next-api-swr';
import { useProvider } from '@newfront-insurance/react-provision';
import type { SWRConfiguration } from 'swr';

import { routes } from '../../bff/routes';
import type { Employee } from '../../bff/types';
import { LayoutConfigProvider } from '../config';

export function useOperationsEmployees(config?: SWRConfiguration): NextApiSubscription<Employee[] | null> {
  const { apiBasePath: basePath } = useProvider(LayoutConfigProvider);

  return useNextApiSubscription<Employee[] | null>(routes.getOperationsEmployees.getUrl({ basePath }), config);
}
